module.exports = __webpack_public_path__ + "img/giftbox.42a34bfe.png";